import React from 'react';
import SchemaFieldRenderer from 'components/schema/SchemaFieldRenderer';
import styles from './LineItemMatchingCriteria.module.css';

function LineItemMatchingCriteria({ schema, criteria, onChange, lookupData }) {
  const handleCriteriaChange = (fieldName, value) => {
    onChange({
      ...criteria,
      [fieldName]: value
    });
  };

  const removeCriteria = (fieldName) => {
    const newCriteria = { ...criteria };
    delete newCriteria[fieldName];
    onChange(newCriteria);
  };

  return (
    <div className={styles.matchingCriteria}>
      <h4>Update line items that match:</h4>
      <div className={styles.criteriaFields}>
        {Object.entries(schema).map(([fieldName, fieldDef]) => (
          <div key={fieldName} className={styles.criteriaField}>
            <label className={styles.criteriaLabel}>
              <input
                type="checkbox"
                checked={criteria.hasOwnProperty(fieldName)}
                onChange={(e) => {
                  if (e.target.checked) {
                    handleCriteriaChange(fieldName, '');
                  } else {
                    removeCriteria(fieldName);
                  }
                }}
              />
              {fieldName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
            </label>
            
            {criteria.hasOwnProperty(fieldName) && (
              <div className={styles.criteriaInput}>
                <SchemaFieldRenderer
                  fieldSchema={fieldDef}
                  fieldName={fieldName}
                  value={criteria[fieldName]}
                  onChange={(value) => handleCriteriaChange(fieldName, value)}
                  isEditing={true}
                  lookupData={lookupData}
                  className={styles.criteriaFieldInput}
                />
              </div>
            )}
          </div>
        ))}
      </div>
      
      {Object.keys(criteria).length > 0 && (
        <div className={styles.criteriaHelp}>
          Only line items where <strong>ALL</strong> selected criteria match will be updated.
          {Object.keys(criteria).length > 1 && (
            <div className={styles.criteriaExample}>
              Example: {Object.keys(criteria).join(' AND ')}
            </div>
          )}
        </div>
      )}
      
      {Object.keys(criteria).length === 0 && (
        <div className={styles.noCriteria}>
          Select criteria above to filter which line items to update.
        </div>
      )}
    </div>
  );
}

export default LineItemMatchingCriteria;